import { render, staticRenderFns } from "./ChartHeader.vue?vue&type=template&id=2fb9f9b3&scoped=true"
import script from "./ChartHeader.vue?vue&type=script&lang=ts"
export * from "./ChartHeader.vue?vue&type=script&lang=ts"
import style0 from "./ChartHeader.vue?vue&type=style&index=0&id=2fb9f9b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9f9b3",
  null
  
)

export default component.exports